export default {
  name: 'summary-history',
  components: {},
  props: [],
  data () {
    return {
      summaries: [],
      checklist: {}
    }
  },
  computed: {

  },
  mounted () {
    this.$loading.start()
    Promise.all([
      this.$store.dispatch('Summary/getAllSummary', {checklist: {id: this.$route.params.checklist_id}}),
      this.$store.dispatch('Checklist/showChecklist', {checklist: {id: this.$route.params.checklist_id}})
    ]).then(res => {
      this.summaries = res[0]
      this.checklist = res[1]
      this.$loading.complete()
    }).catch(errors => {
      this.$loading.fail()
    })
  },
  methods: {
    viewSummary (summary) {
      this.$router.push('' + summary.id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist/view/summary-history/summary-history.js